/* eslint-disable no-dupe-keys */
import { Box, FormControlLabel, Switch, Typography, Button, Tooltip, TextField, InputAdornment, FormControl, Select, MenuItem } from '@mui/material'
import React, { useState } from 'react'
import RadioBoxGroup from '../../../../components/RadioButtons/RadioBoxGroup'
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import SearchIcon from '@mui/icons-material/Search';
import ActivityScreenShotTable from '../Activity/ActivityScreenShotTable'
import ActivityTable from './ActivityTable';
import DeleteTable from './DeleteTable';
import ToggleSwitch from '../../../../components/ToggleSwitch/ToggleSwitch';
const Activity = () => {

    const [activeTab, setActiveTab] = useState('default');

    const [role, setRole] = useState('');
    const handleChangeUser = (event) => {
        setRole(event.target.value);
    };
    const roles = [
        { label: '1X', },
        { label: '2X', },
        { label: '3X', }

    ];

    const activityBtnStyle = {
        fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '14px' },
        padding: { xl: '8px 16px', lg: '8px 12px', md: '8px 12px', sm: '8px 12px', xs: '8px 16px' },
    }
    return (
        <>
            <Box className='featuresetting-sec' sx={{
                overflowX: { xs: 'auto', sm: 'auto', md: 'auto', xl: 'auto', lg: 'auto' },
                maxWidth: '100%',
            }}>
                {/* Tabs */}
                <Box display="inline-flex"
                    gap={1}
                    mb={0}
                    sx={{
                        flexWrap: 'nowrap',
                        minWidth: 'max-content',
                        paddingBottom: '6px'
                    }}>
                    <Button onClick={() => setActiveTab('default')} variant="contained" sx={{
                        ...activityBtnStyle,
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff',
                        backgroundColor: activeTab === 'default' ? '#0076FE' : '#fff', color: activeTab === 'default' ? '#fff' : '#64748B', border: activeTab === 'default' ? '1px solid #0076FE' : '1px solid #D0D5DD',
                        fontWeight: 600, boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }} >
                        Track apps & URLs</Button>
                    <Button onClick={() => setActiveTab('complete')} variant="contained" sx={{
                        ...activityBtnStyle,
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff', backgroundColor: activeTab === 'complete' ? '#0076FE' : '#fff',
                        color: activeTab === 'complete' ? '#fff' : '#64748B', border: activeTab === 'complete' ? '1px solid #0076FE' : '1px solid #D0D5DD', fontWeight: 600,
                        boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }}>Screenshot frequency
                    </Button>

                    <Button onClick={() => setActiveTab('edittab')} variant="contained" sx={{
                        ...activityBtnStyle,
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff', backgroundColor: activeTab === 'edittab' ? '#0076FE' : '#fff',
                        color: activeTab === 'edittab' ? '#fff' : '#64748B', border: activeTab === 'edittab' ? '1px solid #0076FE' : '1px solid #D0D5DD', fontWeight: 600,
                        boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }}>Screenshot blur
                    </Button>

                    <Button onClick={() => setActiveTab('deletesstab')} variant="contained" sx={{
                        ...activityBtnStyle,
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff', backgroundColor: activeTab === 'deletesstab' ? '#0076FE' : '#fff',
                        color: activeTab === 'deletesstab' ? '#fff' : '#64748B', border: activeTab === 'deletesstab' ? '1px solid #0076FE' : '1px solid #D0D5DD', fontWeight: 600,
                        boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }}>Delete screenshots
                    </Button>

                    <Button onClick={() => setActiveTab('privacydatatab')} variant="contained" sx={{
                        ...activityBtnStyle,
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff', backgroundColor: activeTab === 'privacydatatab' ? '#0076FE' : '#fff',
                        color: activeTab === 'privacydatatab' ? '#fff' : '#64748B', border: activeTab === 'privacydatatab' ? '1px solid #0076FE' : '1px solid #D0D5DD', fontWeight: 600,
                        boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }}>Data privacy
                    </Button>

                    <Button onClick={() => setActiveTab('recordtabs')} variant="contained" sx={{
                        ...activityBtnStyle,
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff', backgroundColor: activeTab === 'recordtabs' ? '#0076FE' : '#fff',
                        color: activeTab === 'recordtabs' ? '#fff' : '#64748B', border: activeTab === 'recordtabs' ? '1px solid #0076FE' : '1px solid #D0D5DD',
                        boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }}>Record activity
                    </Button>
                </Box>
                {/* Tab Panel Content */}
            </Box>



            <Box sx={{ '& MuiBox-root': { padding: '0' } }}>
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="default">
                    <Box>
                        <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                            Track apps & URLs
                            <Tooltip title="This setting allows you to automatically assign members to a specific role when creating new projects. Choosing 'None' will disable automatic member assignments." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Manage the tracking of application names and visited URLs while using Hubstaff Desktop apps.</Typography>
                    </Box>
                    <Box sx={{ m: '32px auto 24px', paddingBottom: '24px', borderBottom: '1px solid #D0D4E4', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                        <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                            Global Setting
                            <Tooltip title="Organization default: All current and future members will automatically receive this setting." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>

                        </Typography>
                        <RadioBoxGroup
                            options={['Off', 'Apps', 'Apps & URLs']}
                            defaultValue="None"
                            row={true}
                        />
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ marginBottom: '20px', flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', sx: 'wrap' } }}>
                        <Box sx={{ marginBottom: '10px' }}>
                            <Typography sx={{ fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, fontWeight: '600', color: '#1E1E1E', fontFamily: 'Manrope' }}>Individual settings</Typography>
                            <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#9095A1', fontFamily: 'Manrope' }}>Customize settings for selected members instead of using the organization default.</Typography>
                        </Box>
                        <TextField sx={{ width: { xl: 'auto', lg: 'auto', md: 'auto', sm: '100%', xs: '100%' } }}
                            placeholder="Search Member"
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                sx: { marginBottom: '10px', width: '100%', borderRadius: '20px', background: '#fff', fontSize: '13px', minWidth: { xl: '250px', lg: '250px', md: '180px', sm: '180px', xs: '160px' }, fontFamily: 'Manrope' },
                            }}
                        />
                    </Box>
                    <ActivityTable />
                </CustomTabPanel>

                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="complete">
                    <Box>
                        <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                            Screenshot frequency
                            <Tooltip title="This setting allows you to automatically assign members to a specific role when creating new projects. Choosing 'None' will disable automatic member assignments." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Manage the tracking of application names Adjust the frequency of screenshots captured within a 10-minute timeframe.</Typography>
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ m: '16px auto 32px', p: '14px 12px', border: '1px solid #0076FE', borderRadius: '8px', backgroundColor: '#0076FE0A' }}>
                        <Typography display="flex" alignItems="center" sx={{ width: '80%', gap: '10px', fontSize: '15px', fontWeight: '500', color: '#0076FE', fontFamily: 'Manrope' }}><img class="img-fluid" alt="Budget Icon" src="./assets/images/app-activity/projects/icons/lock-icon.svg" />
                            Boost compliance and security with increased screenshot frequency. Get the More Screenshots add-on to capture up to ten screenshots every ten minutes</Typography>

                        <Button variant="contained" sx={{ ...activityBtnStyle, boxShadow: 'none', width: { xl: '120px', lg: '95px', md: '95px', sm: '90px', xs: '90' }, fontFamily: 'Manrope', height: '38px', borderRadius: '100px', backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', textTransform: 'capitalize' }} >
                            Add-On</Button>
                    </Box>
                    <Box sx={{ m: '32px auto 24px', paddingBottom: '24px', borderBottom: '1px solid #D0D4E4', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                        <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                            Global Setting
                            <Tooltip title="Organization default: All current and future members will automatically receive this setting." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <Box display="flex" alignItems="center" sx={{ gap: '12px' }}>
                            <Box sx={{ width: 200 }}>
                                <FormControl fullWidth variant="outlined" size="small">
                                    <Select value={role} onChange={handleChangeUser} displayEmpty renderValue={(selected) => selected ? (selected) : (
                                        <Typography color="text.secondary" sx={{ fontSize: '14px', color: '#64748B', fontWeight: '400', fontFamily: 'Manrope', }}>
                                            1X
                                        </Typography>
                                    )}
                                        sx={{ backgroundColor: 'white', fontFamily: 'Manrope', fontSize: '14px', color: '#64748B', borderRadius: '100px' }}>
                                        {roles.map((option) => (
                                            <MenuItem key={option.label} value={option.label}>
                                                <Box>
                                                    <Typography variant="body1" sx={{ fontSize: '14px', color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>{option.label}</Typography>
                                                </Box>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Button variant="contained" sx={{ ...activityBtnStyle, boxShadow: 'none', fontFamily: 'Manrope', height: '38px', borderRadius: '100px', backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', textTransform: 'capitalize' }} >
                                Apply to all</Button>
                        </Box>
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ marginBottom: '20px', flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', sx: 'wrap' } }}>
                        <Box sx={{ marginBottom: '10px' }}>
                            <Typography sx={{ fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, fontWeight: '600', color: '#1E1E1E', fontFamily: 'Manrope' }}>Individual settings</Typography>
                            <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#9095A1', fontFamily: 'Manrope' }}>Customize settings for selected members instead of using the organization default.</Typography>
                        </Box>
                        <TextField sx={{ width: { xl: 'auto', lg: 'auto', md: 'auto', sm: '100%', xs: '100%' } }}
                            placeholder="Search Member"
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                sx: { marginBottom: '10px', width: '100%', borderRadius: '20px', background: '#fff', fontSize: '13px', minWidth: { xl: '250px', lg: '250px', md: '180px', sm: '180px', xs: '160px' }, fontFamily: 'Manrope' },
                            }}
                        />
                    </Box>
                    <ActivityScreenShotTable />
                </CustomTabPanel>

                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="edittab">
                    <Box>
                        <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                            Screenshot blur
                            <Tooltip title="This setting allows you to automatically assign members to a specific role when creating new projects. Choosing 'None' will disable automatic member assignments." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Toggle the desktop app's screenshot blur feature to enhance your security and privacy.</Typography>
                    </Box>
                    <Box sx={{ m: '32px auto 24px', paddingBottom: '24px', borderBottom: '1px solid #D0D4E4', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                        <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                            Global Setting
                            <Tooltip title="Organization default: All current and future members will automatically receive this setting." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>

                        </Typography>
                        <RadioBoxGroup
                            options={['Off', 'On']}
                            defaultValue="None"
                            row={true}
                        />
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ marginBottom: '20px', flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', sx: 'wrap' } }}>
                        <Box sx={{ marginBottom: '10px' }}>
                            <Typography sx={{ fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, fontWeight: '600', color: '#1E1E1E', fontFamily: 'Manrope' }}>Individual settings</Typography>
                            <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#9095A1', fontFamily: 'Manrope' }}>Customize settings for selected members instead of using the organization default.</Typography>
                        </Box>
                        <TextField sx={{ width: { xl: 'auto', lg: 'auto', md: 'auto', sm: '100%', xs: '100%' } }}
                            placeholder="Search Member"
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                sx: { marginBottom: '10px', width: '100%', borderRadius: '20px', background: '#fff', fontSize: '13px', minWidth: { xl: '250px', lg: '250px', md: '180px', sm: '180px', xs: '160px' }, fontFamily: 'Manrope' },
                            }}
                        />
                    </Box>
                    <ActivityTable />
                </CustomTabPanel>


                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="deletesstab">
                    <Box>
                        <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                            Delete screenshots
                            <Tooltip title="This setting allows you to automatically assign members to a specific role when creating new projects. Choosing 'None' will disable automatic member assignments." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Enable managers and owners to remove screenshots.</Typography>
                    </Box>
                    <Box sx={{ m: '32px auto 24px', paddingBottom: '24px', borderBottom: '1px solid #D0D4E4', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                        <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                            Global Setting
                            <Tooltip title="Organization default: All current and future members will automatically receive this setting." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>

                        </Typography>
                        <RadioBoxGroup
                            options={['Off', 'Apps', 'Apps & URLs']}
                            defaultValue="None"
                            row={true}
                        />
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ marginBottom: '20px', flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', sx: 'wrap' } }}>
                        <Box sx={{ marginBottom: '10px' }}>
                            <Typography sx={{ fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, fontWeight: '600', color: '#1E1E1E', fontFamily: 'Manrope' }}>Individual settings</Typography>
                            <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#9095A1', fontFamily: 'Manrope' }}>Customize settings for selected members instead of using the organization default.</Typography>
                        </Box>
                        <TextField sx={{ width: { xl: 'auto', lg: 'auto', md: 'auto', sm: '100%', xs: '100%' } }}
                            placeholder="Search Member"
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                sx: { marginBottom: '10px', width: '100%', borderRadius: '20px', background: '#fff', fontSize: '13px', minWidth: { xl: '250px', lg: '250px', md: '180px', sm: '180px', xs: '160px' }, fontFamily: 'Manrope' },
                            }}
                        />
                    </Box>
                    <DeleteTable />
                </CustomTabPanel>


                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="privacydatatab">
                    <Box>
                        <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                            Data privacy
                            <Tooltip title="This setting allows you to automatically assign members to a specific role when creating new projects. Choosing 'None' will disable automatic member assignments." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Activating this option will obscure the apps and URLs of individual members on dashboards. Reports and activity pages related to apps and URLs will be concealed.</Typography>
                    </Box>
                    <Box sx={{ m: '32px auto 24px', paddingBottom: '24px', borderBottom: '1px solid #D0D4E4', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                        <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                            Global Setting
                            <Tooltip title="Organization default: All current and future members will automatically receive this setting." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <ToggleSwitch />

                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ marginBottom: '20px', flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', sx: 'wrap' } }}>
                        <Box sx={{ marginBottom: '10px' }}>
                            <Typography sx={{ fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, fontWeight: '600', color: '#1E1E1E', fontFamily: 'Manrope' }}>Individual settings</Typography>
                            <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#9095A1', fontFamily: 'Manrope' }}>Customize settings for selected members instead of using the organization default.</Typography>
                        </Box>
                        <TextField sx={{ width: { xl: 'auto', lg: 'auto', md: 'auto', sm: '100%', xs: '100%' } }}
                            placeholder="Search Member"
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                sx: { marginBottom: '10px', width: '100%', borderRadius: '20px', background: '#fff', fontSize: '13px', minWidth: { xl: '250px', lg: '250px', md: '180px', sm: '180px', xs: '160px' }, fontFamily: 'Manrope' },
                            }}
                        />
                    </Box>
                    <DeleteTable />
                </CustomTabPanel>

                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="recordtabs">
                    <Box>
                        <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                            Record activity
                            <Tooltip title="This setting allows you to automatically assign members to a specific role when creating new projects. Choosing 'None' will disable automatic member assignments." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Manage the tracking of your keyboard and mouse usage.</Typography>
                    </Box>
                    <Box sx={{ m: '32px auto 24px', paddingBottom: '24px', borderBottom: '1px solid #D0D4E4', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                        <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                            All users
                            <Tooltip title="Organization default: All current and future members will automatically receive this setting." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <ToggleSwitch />

                    </Box>

                </CustomTabPanel>

            </Box>


        </>
    )
}
const CustomTabPanel = ({ value, index, children }) => {
    if (value !== index) return null;
    return <Box sx={{ padding: { xl: '16px 5px', lg: '15px 0', md: '15px 0', sm: '15px  0', sx: '15px 0' } }}>{children}</Box>;
};


export default Activity
